export const MAX_IMAGE_WIDTH = 750;
export const MIN_IMAGE_WIDTH = 100;
export const MIN_PDF_WIDTH = 100;
export const MAX_PDF_WIDTH = 750;
